import { Component, HostListener, OnDestroy, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { IConfigLogin } from '../../interfaces/config-login.interface';
import { AuthService } from '../../services/auth-service/auth.service';
import { DataLoginService } from '../../services/dataLogin/data-login.service';
import { ActivatedRoute, Router } from '@angular/router';
import {
  IForfotPassword,
  ITypeAth,
} from '../../interfaces/type-auth.interface';
import { IDataAuth } from '../../interfaces/data-auth.interface';
import { JwtHelperService } from '@auth0/angular-jwt';
import { Subscription, firstValueFrom } from 'rxjs';
import { TranslateService } from '../../services/translate/translate.service';
import { ToastrService } from 'ngx-toastr';
import { PasskeysService } from '../../services/passkeys/passkeys.service';
import { startAuthentication } from '@simplewebauthn/browser';
import { AuthenticationResponseJSON } from '@simplewebauthn/typescript-types';
import { RegisterService } from '../../services/register/register.service';
import { MangoEventAnalyticsService } from '../../services/mango-events-analytics/mango-events-analytics.service';

interface TranslateData {
  user: string;
  userRequired: string;
  password: string;
  buttonLogin: string;
  forgotPassword: string;
  titleToast: string;
  contentToast: string;
  textLoading: string;
  userNotFound: string;
  messageChangesPassword: string;
  authPasseys: string;
  or: string;
  authRegister: string;
}

@Component({
  selector: 'lib-landing',
  templateUrl: './landing.component.html',
  styleUrls: ['./landing.component.scss'],
})
export class LandingComponent implements OnInit, OnDestroy {
  translate: TranslateData = {} as TranslateData;
  dataLogin: IConfigLogin = {
    version: '0.0.0',
    route: '/dashboard',
    url: '',
  };
  typeAuth: ITypeAth = {
    type: 'sms',
    statusModal: false,

    ...this.dataLogin,
  };
  tamWidth = 768;
  invalidForm: boolean = false;
  loading: boolean = false;
  loadingPasskeys: boolean = false;

  isOpenModalTwoAuth = false;
  formLogin!: FormGroup;
  messageError = {
    username: {
      required: '¡User required!',
      minlength: 'User invald',
    },
    password: {
      required: 'Password required!',
      minlength: 'Password invalid',
      maxlength: 'Password invalid',
    },
  };
  isTypePassword: string = 'password';
  validUser: 'pending' | 'loading' | 'valid' | 'invalid' = 'pending';
  subscriptionAuth$!: Subscription;
  subscriptionTranslate!: Subscription;
  isModalOpenForgotPassword: IForfotPassword = {} as IForfotPassword;
  params!: any;
  viewRedirectRegister: boolean = false;
  viewRedirectAccessRegister: boolean = false;
  hiddenButtonPasskey: boolean = false;
  viewSingUp: boolean = true;
  constructor(
    private authService: AuthService,
    private fb: FormBuilder,
    private router: Router,
    private serviceDataLogin: DataLoginService,
    private route: ActivatedRoute,
    private jwt: JwtHelperService,
    private translateService: TranslateService,
    private toastAlert: ToastrService,
    private passKeyService: PasskeysService,
    private registerService: RegisterService,
    private mangoEventAnalyticsService: MangoEventAnalyticsService
  ) {
    this.tamWidth = window.innerWidth;
  }

  ngOnInit(): void {
    const config = this.serviceDataLogin.configData;
    this.hiddenButtonPasskey = config?.hiddenButtonPasskey || false;
    if (!config) {
      this.serviceDataLogin.configObservable.subscribe((config) => {
        this.hiddenButtonPasskey = config?.hiddenButtonPasskey || false;
        if (
          config &&
          config?.CONFIG_REGISTER &&
          config?.CONFIG_REGISTER?.viewRegister
        ) {
          this.viewRedirectAccessRegister = true;
          this.validViewRedirect();
        }
      });
    } else {
      if (
        config &&
        config?.CONFIG_REGISTER &&
        config?.CONFIG_REGISTER?.viewRegister
      ) {
        this.viewRedirectAccessRegister = true;
        this.validViewRedirect();
      }
    }
    this.route.queryParamMap.subscribe((data: any) => {
      this.params = data.params;
      this.validViewRedirect();
    });
    this.dataTranslate();
    this.dataLogin = this.serviceDataLogin.login();
    this.dataForm();
  }

  validViewRedirect() {
    this.viewRedirectRegister = this.params?.signup
      ? this.params?.signup === 'false'
        ? false
        : true
      : this.viewRedirectAccessRegister;
  }

  keyPress() {
    if (this.validUser === 'pending' || this.validUser === 'invalid') {
      this.validEmail();
    }
  }
  async authPasskeys() {
    this.invalidForm = true;
    this.loadingPasskeys = true;
    const username = this.formLogin.value.username;
    this.mangoEventAnalyticsService.sendEvent('passkeys_login_attempt', {
      username: username,
      timestamp: new Date().toISOString(),
    });
    this.passKeyService.getCredentials(this.dataLogin.url, username).subscribe(
      (resp: any) => {
        if (resp.data.credentials?.allowCredentials) {
          const challenge = resp.data.credentials.challenge;
          startAuthentication(resp.data.credentials).then(
            (auth: AuthenticationResponseJSON) => {
              this.passKeyService
                .validateLogin(this.dataLogin.url, auth, challenge, username)
                .subscribe((data: any) => {
                  this.authService.setToken(
                    data.data.jwtToken,
                    data.data.refreshToken
                  );
                  const decodedToken = this.jwt.decodeToken(data.data.jwtToken);
                  const title = this.translate.titleToast;
                  const content = `${this.translate.contentToast} , ${decodedToken.username}`;
                  this.toastAlert.success(title, content);
                  this.mangoEventAnalyticsService.sendEvent(
                    'passkeys_login_success',
                    {
                      username: decodedToken.username,
                      timestamp: new Date().toISOString(),
                    }
                  );

                  if (
                    this.authService.getUrlRedirectLogin() &&
                    this.authService.getUrlRedirectLogin().length > 0
                  ) {
                    this.router.navigateByUrl(
                      this.authService.getUrlRedirectLogin()
                    );
                  } else {
                    let queryParams: any = {};
                    if (this.params) {
                      queryParams = this.params;
                    }
                    setTimeout(() => {
                      this.router
                        .navigate([`/${this.dataLogin.route}`], { queryParams })
                        .then();
                    }, 2000);
                    this.invalidForm = false;
                    this.loadingPasskeys = false;
                  }
                });
            },
            (error) => {
              this.invalidForm = false;
              this.loadingPasskeys = false;
              this.mangoEventAnalyticsService.sendEvent(
                'passkeys_login_error',
                {
                  username: username,
                  error: error.message || 'Unknown error',
                  timestamp: new Date().toISOString(),
                }
              );
              console.error(error);
            }
          );
        } else {
          this.isOpenModalTwoAuth = true;
          this.invalidForm = false;
          this.loadingPasskeys = false;
          this.mangoEventAnalyticsService.sendEvent('passkeys_not_available', {
            username: username,
            timestamp: new Date().toISOString(),
          });
        }
      },
      (error) => {
        this.invalidForm = false;
        this.loadingPasskeys = false;
        this.mangoEventAnalyticsService.sendEvent('passkeys_login_error', {
          username: username,
          error: error.message || 'Unknown error',
          timestamp: new Date().toISOString(),
        });
      }
    );
  }

  @HostListener('window:resize', ['$event'])
  onResize(event: any) {
    this.tamWidth = event.target.innerWidth;
  }

  async validEmail() {
    if (this.formLogin.value.username.length > 0) {
      this.validUser = 'loading';
      const resp = await firstValueFrom(
        this.registerService.validateUsername(
          this.dataLogin.url,
          this.formLogin.value.username
        )
      );
      if (resp.elementFind && !resp.hasPassword) {
        this.isModalOpenForgotPassword = {
          statusModal: true,
          type: 'reset',
          text: '',
          url: this.dataLogin.url,
        } as IForfotPassword;
        this.validUser = 'pending';
      } else {
        this.validUser = resp.elementFind ? 'valid' : 'invalid';
      }
    }
  }
  dataForm() {
    this.formLogin = this.fb.group({
      username: ['', [Validators.required]],
      password: ['', [Validators.required]],
    });
  }
  showPassword() {
    this.isTypePassword =
      this.isTypePassword === 'password' ? 'text' : 'password';
  }

  async login() {
    this.invalidForm = true;
    this.loading = true;
    const username = this.formLogin.value.username.trim();
    let payload: IDataAuth = {
      username: username,
      password: this.formLogin.value.password.trim(),
    };
    this.mangoEventAnalyticsService.sendEvent('login_attempt', {
      username: username,
      timestamp: new Date().toISOString(),
    });
    if (
      this.params &&
      this.params?.login_provider &&
      JSON.parse(this.params['login_provider'] || 'false') == true
    ) {
      payload['login_provider'] = true;
    }
    this.subscriptionAuth$ = this.authService
      .login(payload, this.dataLogin.url)
      .subscribe(
        (resp: any) => {
          this.loading = false;
          switch (resp.typeLogin) {
            case 'password':
              this.authService.setToken(resp.jwtToken, resp?.refreshToken);
              const decodedToken = this.jwt.decodeToken(resp.jwtToken);
              const title = this.translate.titleToast;
              const content = `${this.translate.contentToast} , ${decodedToken.username}`;
              this.toastAlert.success(title, content);
              if (this.dataLogin.websocketUrl && this.params) {
                const authWsChannel = this.params?.authWsChannel || '';
                const wsUrl = this.dataLogin.websocketUrl;
                this.authService.emitDataWs(wsUrl, authWsChannel, {
                  event: 'authenticated',
                  data: {
                    message: 'Authenticated successfully',
                    accessToken: resp.jwtToken,
                    refreshToken: resp.refreshToken,
                    tokenType: 'Bearer',
                    expiresIn: decodedToken.exp,
                  },
                });
              }
              this.mangoEventAnalyticsService.sendEvent('login_success', {
                username: decodedToken.username,
                login_type: 'password',
                timestamp: new Date().toISOString(),
              });

              if (
                this.authService.getUrlRedirectLogin() &&
                this.authService.getUrlRedirectLogin().length > 0
              ) {
                this.router.navigateByUrl(
                  this.authService.getUrlRedirectLogin()
                );
              } else {
                let queryParams: any = {};
                if (this.params) {
                  queryParams = this.params;
                }
                setTimeout(() => {
                  this.router
                    .navigate([`/${this.dataLogin.route}`], { queryParams })
                    .then();
                }, 2000);
                this.invalidForm = false;
              }

              break;
            case 'sms':
              this.typeAuth = {
                type: resp.typeLogin,
                statusModal: true,
                ...this.dataLogin,
                user: resp.user,
                sms: {
                  timeExp: resp.timeExp,
                  message: resp.message,
                },
              };
              this.invalidForm = false;
              this.mangoEventAnalyticsService.sendEvent(
                'login_two_factor_required',
                {
                  username: username,
                  two_factor_type: 'sms',
                  timestamp: new Date().toISOString(),
                }
              );
              break;
            case 'totp':
              this.typeAuth = {
                ...this.dataLogin,
                type: resp.typeLogin,
                statusModal: true,
                user: resp.user,
                totp: {
                  qrCode: resp.qrCode,
                  base32Secret: resp.base32Secret,
                },
              };
              this.invalidForm = false;
              this.mangoEventAnalyticsService.sendEvent(
                'login_two_factor_required',
                {
                  username: username,
                  two_factor_type: 'totp',
                  timestamp: new Date().toISOString(),
                }
              );
              break;
            case 'modifyPassword':
              this.forgotPassword(this.translate.messageChangesPassword || '');
              this.invalidForm = false;
              break;
          }
        },
        (err) => {
          this.loading = false;
          this.invalidForm = false;
          this.mangoEventAnalyticsService.sendEvent('login_error', {
            username: username,
            error: err.error?.message || 'Internal server error',
            timestamp: new Date().toISOString(),
          });
          return this.toastAlert.error(
            'Error authentication',
            err.error?.message || 'Internal server error'
          );
        }
      );
  }

  closeModalAuth(event: any) {
    this.typeAuth = event;
  }

  getError(nameError: string = ''): string {
    if (!this.formLogin.get(nameError)?.touched) {
      return '';
    }
    const errors = this.formLogin.get(nameError)?.errors || {};
    const error = Object.keys(errors)[0];
    type typeMessage = typeof this.messageError;
    const objectMsg = this.messageError[nameError as keyof typeMessage];
    type typeObject = typeof objectMsg;
    return objectMsg[error as keyof typeObject];
  }
  dataTranslate() {
    this.subscriptionTranslate = this.translateService
      .init('core')
      .subscribe((data) => {
        this.translate = data.login.loginForm;
      });
  }
  redirectRegister() {
    let queryParams: any = {};
    if (this.params) {
      queryParams = this.params;
    }
    this.mangoEventAnalyticsService.sendEvent('register_click', {
      timestamp: new Date().toISOString(),
    });
    this.router.navigate([`/register`], {
      queryParams,
    });
  }

  forgotPassword(text: string = '') {
    let queryParams: any = {};
    if (this.params) {
      queryParams = this.params;
    }
    this.mangoEventAnalyticsService.sendEvent('forgot_password_click', {
      username: this.formLogin.value.username || '',
      timestamp: new Date().toISOString(),
    });
    this.router.navigate([`/forgot-password`], {
      queryParams,
    });
  }

  ngOnDestroy(): void {
    this.subscriptionTranslate?.unsubscribe();
    this.subscriptionAuth$?.unsubscribe();
  }
}
